// Aceleres: garante "apenas um modal por vez" na página de conversa.
// Quando um modal registra sua função de fechamento, todos os modais
// atualmente registrados são fechados antes.
//
// Ativa somente quando a rota atual for /accounts/:id/conversations/...
// para não quebrar fluxos com modais aninhados em outras telas
// (ex: settings, campaigns) que dependem de stack de dialogs.

const openModals = new Set();

const isOnConversationRoute = () => {
  if (typeof window === 'undefined') return false;
  return /\/accounts\/\d+\/conversations(\/|$)/.test(
    window.location.pathname
  );
};

export function registerModal(closer) {
  if (typeof closer !== 'function') return;

  if (isOnConversationRoute()) {
    const current = Array.from(openModals);
    openModals.clear();
    current.forEach(c => {
      if (c === closer) return;
      try {
        c();
      } catch {
        // fechamento defensivo: ignora erros do closer para não
        // travar o registro do novo modal
      }
    });
  }

  openModals.add(closer);
}

export function unregisterModal(closer) {
  openModals.delete(closer);
}
